import { gql } from '@apollo/client';
import { DealStageFragment } from '../fragments/DealStageFragment';
/**
 * @const DealStagesQuery
 * @since 1.0.0
 */
export const DealStagesQuery = gql `
  query DealStagesQuery($input: DealStagesInput) {
    dealStages(input: $input) {
      ...DealStageFragment
    }
  }
  ${DealStageFragment}
`;
